import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material/styles';

const SelectSubEstadoInstCancelada = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti,
    estadoEsp
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const [options, setOptions] = useState([
        {
          value: 'TIEMPO DE ESPERA',
          label: 'TIEMPO DE ESPERA',
        },
        {
          value: 'NO CUENTA CON TARJETA DE CREDITO',
          label: 'NO CUENTA CON TARJETA DE CREDITO',
        },
        {
          value: 'NO BRINDA MOTIVO',
          label: 'NO BRINDA MOTIVO',
        },
        {
          value: 'CLIENTE NO CONTESTA',
          label: 'CLIENTE NO CONTESTA',
        },
        {
          value: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
          label: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
        },
        {
          value: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
          label: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
        },
        {
          value: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
          label: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
        },
        {
          value: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
          label: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
        },
        {
          value: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
          label: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
        }
    ]);
    useEffect(() => {
        if(estadoEsp){
            setOptions([
                {
                  value: 'TIEMPO DE ESPERA',
                  label: 'TIEMPO DE ESPERA',
                },
                {
                  value: 'NO CUENTA CON TARJETA DE CREDITO',
                  label: 'NO CUENTA CON TARJETA DE CREDITO',
                },
                {
                  value: 'NO BRINDA MOTIVO',
                  label: 'NO BRINDA MOTIVO',
                },
                {
                  value: 'CLIENTE NO CONTESTA',
                  label: 'CLIENTE NO CONTESTA',
                },
                {
                  value: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
                  label: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
                },
                {
                  value: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
                  label: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
                },
                {
                  value: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
                  label: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
                },
                {
                  value: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
                  label: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
                },
                {
                  value: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
                  label: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
                },
                {
                  value: 'PRE-SERVICIO DUPLICADO',
                  label: 'PRE-SERVICIO DUPLICADO',
                },
                {
                  value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                  label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                },
            ])
        }
    }, [estadoEsp])
    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            backgroundColor: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            borderRadius: 7,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
            borderRadius: 5,
            border: isDarkMode ? '1px solid #fff' : 'none',
        }),
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5,
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectSubEstadoInstCancelada.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectSubEstadoInstCancelada;